(function () {
  'use strict';

  function detectMonths(value) {
    var text = String(value || '').toLowerCase();
    var match = text.match(/(\d+)\s*mois/);
    if (match) return parseInt(match[1], 10);

    match = text.match(/(\d+)\s*months?/);
    if (match) return parseInt(match[1], 10);

    match = text.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }

  function findPlan(tier) {
    var plans = tier && tier.variant && tier.variant.plans
      ? tier.variant.plans
      : [];

    if (!plans.length) return null;
    if (plans.length === 1) return plans[0];

    for (var i = 0; i < plans.length; i += 1) {
      if (detectMonths(plans[i].name) === tier.months) return plans[i];
    }

    return plans[0];
  }

  function formatMoney(cents, currency, locale) {
    var numberLocale = locale === 'en' ? 'en-GB' : 'fr-FR';

    try {
      return new Intl.NumberFormat(numberLocale, {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function escapeMoneyPart(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /*
    Monthly price must render as one continuous locale-formatted string.
    Splitting integer / separator / fraction into separate inline boxes creates
    visible gaps around the decimal comma with some browser/font combinations.
  */
  function formatMonthlyMoney(cents, currency, locale) {
    var numberLocale = locale === 'en' ? 'en-GB' : 'fr-FR';

    try {
      return escapeMoneyPart(
        new Intl.NumberFormat(numberLocale, {
          style: 'currency',
          currency: currency || 'EUR',
          minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
          maximumFractionDigits: 2
        }).format(cents / 100)
      );
    } catch (error) {
      return escapeMoneyPart(formatMoney(cents, currency, locale));
    }
  }

  function track(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(
        Object.assign(
          {
            event: eventName
          },
          params || {}
        )
      );
    } catch (error) {}
  }

  function init(root) {
    if (!root || root.dataset.ecloSuppV15Ready === 'true') return;

    var dataNode = root.querySelector('[data-eclo-supp-data-v15]');
    if (!dataNode) return;

    var data;

    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var locale = String(
      root.dataset.locale ||
      document.documentElement.lang ||
      'fr'
    )
      .toLowerCase()
      .split('-')[0];

    var country = String(root.dataset.country || '').toUpperCase();

    var orderLabel = root.dataset.i18nOrder || 'Commander';

    var startRoutineLabel =
      root.dataset.i18nStartRoutine ||
      'Commencer ma routine';

    var unavailableLabel =
      root.dataset.i18nUnavailable ||
      'Indisponible';

    var monthSingular =
      root.dataset.i18nMonthSingular ||
      'mois';

    var monthPlural =
      root.dataset.i18nMonthPlural ||
      'mois';

    var perMonthLabel =
      root.dataset.i18nPerMonth ||
      'par mois';

    var totalSuffix =
      root.dataset.i18nTotalSuffix ||
      'au total';

    var savedSuffix =
      root.dataset.i18nSavedSuffix ||
      'économisés';

    var subscriptionWord =
      root.dataset.i18nSubscription ||
      'Abonnement';

    var subscriptionNoteSuffix =
      root.dataset.i18nSubscriptionNoteSuffix ||
      'Modifiable, en pause ou résiliable à tout moment.';

    var onetimeNote =
      root.dataset.i18nOnetimeNote ||
      'Achat ponctuel · Sans engagement.';

    var shippingFreeFrom =
      root.dataset.i18nShippingFreeFrom ||
      'Livraison offerte dès';

    var shippingIncluded =
      root.dataset.i18nShippingIncluded ||
      'Incluse avec cette option';

    var shippingRemaining =
      root.dataset.i18nShippingRemaining ||
      'Plus que';

    function monthWord(months) {
      return months === 1
        ? monthSingular
        : monthPlural;
    }

    var tiers = (data.variants || [])
      .map(function (variant) {
        return {
          months: detectMonths(variant.title),
          variant: variant
        };
      })
      .sort(function (a, b) {
        return a.months - b.months;
      });

    if (!tiers.length) {
      root.hidden = true;
      return;
    }

    var configuredDefault =
      parseInt(root.dataset.defaultMonths || '2', 10);

    var popularMonths =
      parseInt(root.dataset.popularMonths || '2', 10);

    var freeShippingThreshold =
      parseInt(root.dataset.freeShippingThreshold || '5000', 10);

    var subscriptionLabel =
      root.dataset.subscriptionLabel ||
      (locale === 'en'
        ? 'Regular delivery'
        : 'Livraison régulière');

    var onetimeLabel =
      root.dataset.onetimeLabel ||
      (locale === 'en'
        ? 'One-time purchase'
        : 'Achat ponctuel');

    var showTierTotal =
      root.dataset.showTierTotal === 'true';

    var showTierSavingsAmount =
      root.dataset.showTierSavingsAmount === 'true';

    var showCtaCompare =
      root.dataset.showCtaComparePrice !== 'false';

    var tierLabels = {
      1:
        root.dataset.tier1Label ||
        (locale === 'en'
          ? 'Discovery'
          : 'Découverte'),

      2:
        root.dataset.tier2Label ||
        (locale === 'en'
          ? 'Most popular'
          : 'Le plus populaire'),

      3:
        root.dataset.tier3Label ||
        (locale === 'en'
          ? 'Best value'
          : 'Meilleure valeur')
    };

    var defaultTier =
      tiers.filter(function (tier) {
        return (
          tier.months === configuredDefault &&
          tier.variant.available
        );
      })[0] ||
      tiers.filter(function (tier) {
        return tier.variant.available;
      })[0] ||
      tiers[0];

    var state = {
      months: defaultTier.months,
      mode:
        root.dataset.defaultMode === 'subscription'
          ? 'subscription'
          : 'onetime'
    };

    if (!findPlan(defaultTier)) {
      state.mode = 'onetime';
    }

    var tiersNode =
      root.querySelector('[data-eclo-supp-tiers-v15]');

    var modesNode =
      root.querySelector('[data-eclo-supp-modes-v15]');

    var modeNoteNode =
      root.querySelector('[data-eclo-supp-mode-note-v15]');

    var shippingNode =
      root.querySelector('[data-eclo-supp-shipping-v15]');

    var variantInput =
      root.querySelector('[data-eclo-supp-variant-input-v15]');

    var planInput =
      root.querySelector('[data-eclo-supp-plan-input-v15]');

    var cta =
      root.querySelector('[data-eclo-supp-cta-v15]');

    var ctaText =
      root.querySelector('[data-eclo-supp-cta-text-v15]');

    var sticky =
      root.nextElementSibling &&
      root.nextElementSibling.matches('[data-eclo-supp-sticky-v15]')
        ? root.nextElementSibling
        : null;

    var stickyButton =
      sticky &&
      sticky.querySelector('[data-eclo-supp-sticky-button-v15]');

    var stickyButtonLabel =
      sticky &&
      sticky.querySelector(
        '[data-eclo-supp-sticky-button-label-v15]'
      );

    var stickyTitle =
      sticky &&
      sticky.querySelector('[data-eclo-supp-sticky-title-v15]');

    var stickyPrice =
      sticky &&
      sticky.querySelector('[data-eclo-supp-sticky-price-v15]');

    var launchBanner =
      document.querySelector('[data-eclo-launch-banner]');

    function tierFor(months) {
      return (
        tiers.filter(function (tier) {
          return tier.months === months;
        })[0] ||
        tiers[0]
      );
    }

    function selectedTier() {
      return tierFor(state.months);
    }

    function planFor(tier) {
      return findPlan(tier);
    }

    function selectedPlan() {
      return state.mode === 'subscription'
        ? planFor(selectedTier())
        : null;
    }

    function priceForMode(tier, mode) {
      var plan =
        mode === 'subscription'
          ? planFor(tier)
          : null;

      return plan
        ? plan.price
        : tier.variant.price;
    }

    function priceFor(tier) {
      return priceForMode(tier, state.mode);
    }

    function currentTotal() {
      return priceFor(selectedTier());
    }

    function monthlyPrice(total, months) {
      return total / Math.max(months, 1);
    }

    /*
      Full-price benchmark = the 1-month one-time price × duration.

      This intentionally stays separate from Shopify compare_at_price so a
      future launch-price treatment can be layered on top without mixing
      discount types.
    */
    var oneMonthTier =
      tiers.filter(function (tier) {
        return tier.months === 1;
      })[0] ||
      tiers[0];

    var regularOneMonthPrice =
      oneMonthTier.variant.compareAtPrice &&
      oneMonthTier.variant.compareAtPrice >
        oneMonthTier.variant.price
        ? oneMonthTier.variant.compareAtPrice
        : oneMonthTier.variant.price;

    var fullUnitPrice =
      regularOneMonthPrice /
      Math.max(oneMonthTier.months, 1);

    function fullPriceFor(tier) {
      return Math.round(
        fullUnitPrice * tier.months
      );
    }

    function savingAmountFor(tier, mode) {
      return Math.max(
        0,
        fullPriceFor(tier) -
          priceForMode(tier, mode)
      );
    }

    function savingPercentFor(tier, mode) {
      var full = fullPriceFor(tier);
      var save =
        savingAmountFor(tier, mode);

      return full > 0 && save > 0
        ? Math.round((save / full) * 100)
        : 0;
    }

    function tierSavingsAmountText(tier, mode) {
      if (!showTierSavingsAmount) return '';

      var amount =
        savingAmountFor(tier, mode);

      return amount > 0
        ? formatMoney(
            amount,
            data.currency,
            locale
          ) +
          ' ' +
          savedSuffix
        : '';
    }

    function additionalSubscriptionPercentFor(tier) {
      var plan = planFor(tier);

      if (
        !plan ||
        !tier ||
        !tier.variant ||
        !tier.variant.price
      ) {
        return 0;
      }

      var oneTime = tier.variant.price;
      var subscription = plan.price;

      if (subscription >= oneTime) {
        return 0;
      }

      return Math.round(
        ((oneTime - subscription) / oneTime) *
          100
      );
    }

    function renderTiers() {
      tiersNode.innerHTML = tiers
        .map(function (tier) {
          var isSelected =
            tier.months === state.months;

          var isPopular =
            tier.months === popularMonths;

          var total =
            priceFor(tier);

          var perMonth =
            monthlyPrice(
              total,
              tier.months
            );

          var unavailable =
            !tier.variant.available;

          var positionLabel =
            tierLabels[tier.months] || '';

          var tierSaving =
            tierSavingsAmountText(
              tier,
              state.mode
            );

          return [
            '<button type="button" class="eclo-offer__tier',
            isSelected ? ' is-selected' : '',
            isPopular ? ' is-popular' : '',
            '" data-months="',
            tier.months,
            '"',
            unavailable
              ? ' disabled aria-disabled="true"'
              : '',
            ' aria-pressed="',
            isSelected ? 'true' : 'false',
            '">',

            isPopular
              ? '<span class="eclo-offer__badge">' +
                positionLabel +
                '</span>'
              : '<span class="eclo-offer__tier-position">' +
                positionLabel +
                '</span>',

            '<span class="eclo-offer__tier-months">',
            tier.months,
            ' ',
            monthWord(tier.months),
            '</span>',

            '<span class="eclo-offer__tier-commerce">',

            '<span class="eclo-offer__tier-price">' +
              formatMonthlyMoney(
                perMonth,
                data.currency,
                locale
              ) +
              '<small>' +
              perMonthLabel +
              '</small></span>',

            showTierTotal &&
            tier.months > 1
              ? '<span class="eclo-offer__tier-total">' +
                formatMoney(
                  total,
                  data.currency,
                  locale
                ) +
                ' ' +
                totalSuffix +
                '</span>'
              : '',

            tierSaving
              ? '<span class="eclo-offer__tier-saving">' +
                tierSaving +
                '</span>'
              : '',

            '</span>',
            '</button>'
          ].join('');
        })
        .join('');

      Array.prototype.forEach.call(
        tiersNode.querySelectorAll('[data-months]'),
        function (button) {
          button.addEventListener(
            'click',
            function () {
              state.months =
                parseInt(
                  button.dataset.months,
                  10
                );

              track(
                'eclo_supp_tier_select',
                {
                  tier_months:
                    state.months
                }
              );

              if (
                state.mode ===
                  'subscription' &&
                !findPlan(selectedTier())
              ) {
                state.mode = 'onetime';
              }

              render();
            }
          );
        }
      );
    }

    function renderModes() {
      var tier =
        selectedTier();

      var plan =
        findPlan(tier);

      var subscriptionExtraPercent =
        plan
          ? additionalSubscriptionPercentFor(
              tier
            )
          : 0;

      var subscriptionExtraText =
        subscriptionExtraPercent > 0
          ? '−' +
            subscriptionExtraPercent +
            '%'
          : '';

      /*
        One-time purchase intentionally appears on the left.

        Subscription keeps the compact historical treatment:
        label + incremental percentage only.
      */
      modesNode.innerHTML = [
        '<button type="button" data-mode="onetime" class="eclo-offer__mode',
        state.mode === 'onetime'
          ? ' is-selected'
          : '',
        '"><span>',
        onetimeLabel,
        '</span></button>',

        '<button type="button" data-mode="subscription" class="eclo-offer__mode',
        state.mode === 'subscription'
          ? ' is-selected'
          : '',
        '"',
        plan ? '' : ' disabled',
        '><span>',
        subscriptionLabel,
        '</span>',

        subscriptionExtraText
          ? '<strong>' +
            subscriptionExtraText +
            '</strong>'
          : '',

        '</button>'
      ].join('');

      Array.prototype.forEach.call(
        modesNode.querySelectorAll('[data-mode]'),
        function (button) {
          button.addEventListener(
            'click',
            function () {
              state.mode =
                button.dataset.mode;

              track(
                'eclo_supp_mode_toggle',
                {
                  purchase_mode:
                    state.mode ===
                    'subscription'
                      ? 'sub'
                      : 'onetime'
                }
              );

              render();
            }
          );
        }
      );
    }

    function renderForm() {
      var tier =
        selectedTier();

      var plan =
        selectedPlan();

      var total =
        currentTotal();

      var fullPrice =
        fullPriceFor(tier);

      var perMonth =
        monthlyPrice(
          total,
          tier.months
        );

      var hasSaving =
        total < fullPrice;

      variantInput.value =
        tier.variant.id;

      variantInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      if (plan) {
        planInput.disabled = false;
        planInput.value = plan.id;

        modeNoteNode.textContent =
          subscriptionWord +
          ' ' +
          tier.months +
          ' ' +
          monthWord(tier.months) +
          ' · ' +
          subscriptionNoteSuffix;
      } else {
        planInput.disabled = true;
        planInput.value = '';

        modeNoteNode.textContent =
          onetimeNote;
      }

      cta.disabled =
        !tier.variant.available;

      if (tier.variant.available) {
        var action =
          state.mode === 'subscription'
            ? startRoutineLabel
            : orderLabel +
              ' ' +
              tier.months +
              ' ' +
              monthWord(tier.months);

        var compareHtml =
          showCtaCompare &&
          hasSaving
            ? ' <s class="eclo-offer__cta-compare">' +
              formatMoney(
                fullPrice,
                data.currency,
                locale
              ) +
              '</s>'
            : '';

        ctaText.innerHTML =
          '<span>' +
          action +
          ' · ' +
          formatMoney(
            total,
            data.currency,
            locale
          ) +
          '</span>' +
          compareHtml;
      } else {
        ctaText.textContent =
          unavailableLabel;
      }

      /*
        Singapore uses the International shipping profile:
        €14.90 below €100 / free from €100.

        The local product prices are already converted to SGD by Shopify,
        while this component's configured threshold is still the FR €50
        merchandising threshold. Comparing those values would therefore
        create a false shipping promise in Singapore.

        Until the component is connected to market-specific shipping
        thresholds, suppress this reassurance only for SG.
      */
      if (shippingNode) {
        if (country === 'SG') {
          shippingNode.hidden = true;
          shippingNode.textContent = '';
        } else {
          shippingNode.hidden = false;

          shippingNode.textContent =
            total >= freeShippingThreshold
              ? shippingFreeFrom +
                ' ' +
                formatMoney(
                  freeShippingThreshold,
                  data.currency,
                  locale
                ) +
                ' · ' +
                shippingIncluded
              : shippingFreeFrom +
                ' ' +
                formatMoney(
                  freeShippingThreshold,
                  data.currency,
                  locale
                ) +
                ' · ' +
                shippingRemaining +
                ' ' +
                formatMoney(
                  freeShippingThreshold -
                    total,
                  data.currency,
                  locale
                );
        }
      }

      if (stickyTitle) {
        stickyTitle.textContent =
          tier.months +
          ' ' +
          monthWord(tier.months) +
          ' · ' +
          (
            state.mode ===
            'subscription'
              ? subscriptionLabel
              : onetimeLabel
          );
      }

      if (stickyPrice) {
        stickyPrice.innerHTML =
          formatMoney(
            perMonth,
            data.currency,
            locale
          ) +
          ' ' +
          perMonthLabel +
          ' · ' +
          formatMoney(
            total,
            data.currency,
            locale
          ) +
          (
            showCtaCompare &&
            hasSaving
              ? ' · <s>' +
                formatMoney(
                  fullPrice,
                  data.currency,
                  locale
                ) +
                '</s>'
              : ''
          );
      }

      if (stickyButtonLabel) {
        stickyButtonLabel.textContent =
          (
            state.mode ===
            'subscription'
              ? startRoutineLabel
              : orderLabel
          ) +
          ' · ' +
          formatMoney(
            total,
            data.currency,
            locale
          );
      }
    }

    function render() {
      renderTiers();
      renderModes();
      renderForm();
    }

    function setupTracking(button) {
      if (
        !button ||
        button.dataset
          .ecloSuppV15TrackingReady ===
          'true'
      ) {
        return;
      }

      button.addEventListener(
        'click',
        function () {
          if (cta.disabled) return;

          var tier =
            selectedTier();

          var total =
            currentTotal();

          var purchaseMode =
            state.mode ===
            'subscription'
              ? 'sub'
              : 'onetime';

          function cleanup() {
            document.removeEventListener(
              'theme:product:added',
              onAdded
            );

            document.removeEventListener(
              'theme:product:add-error',
              onError
            );
          }

          function onAdded() {
            cleanup();

            track(
              'add_to_cart',
              {
                currency:
                  data.currency ||
                  'EUR',

                value:
                  total / 100,

                purchase_mode:
                  purchaseMode,

                items: [
                  {
                    item_id:
                      String(
                        tier.variant.id
                      ),

                    item_name:
                      root.dataset
                        .productTitle ||
                      'Eclo supplement',

                    quantity: 1,

                    price:
                      total / 100,

                    item_variant:
                      String(
                        tier.months
                      ) +
                      '-month'
                  }
                ]
              }
            );
          }

          function onError(event) {
            if (
              !event.detail ||
              !event.detail.button ||
              event.detail.button ===
                cta
            ) {
              cleanup();
            }
          }

          document.addEventListener(
            'theme:product:added',
            onAdded
          );

          document.addEventListener(
            'theme:product:add-error',
            onError
          );
        }
      );

      button.dataset
        .ecloSuppV15TrackingReady =
        'true';
    }

    setupTracking(cta);

    if (stickyButton) {
      stickyButton.addEventListener(
        'click',
        function () {
          cta.click();
        }
      );
    }

    if (
      sticky &&
      'IntersectionObserver' in window
    ) {
      var observer =
        new IntersectionObserver(
          function (entries) {
            var entry =
              entries[0];

            var hasPassedCta =
              !entry.isIntersecting &&
              entry.boundingClientRect.top <
                0;

            sticky.hidden =
              !hasPassedCta;

            if (launchBanner) {
              launchBanner.classList.toggle(
                'is-suppressed-by-sticky',
                hasPassedCta
              );
            }
          },
          {
            threshold: 0.05
          }
        );

      observer.observe(cta);
    }

    render();

    root.dataset.ecloSuppV15Ready =
      'true';
  }

  function boot(scope) {
    var root =
      scope || document;

    Array.prototype.forEach.call(
      root.querySelectorAll(
        '[data-eclo-supp-offer-v15]'
      ),
      init
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      }
    );
  } else {
    boot(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      boot(event.target);
    }
  );
})();